import styled from "styled-components";

export const MobileLangSwitcherMenuItemSelectedLangBox = styled.span`
  display: block;
  margin: 0 0 0 auto;
  font-family: ${props => props.theme.font.family.regular};
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 1;
  text-transform: uppercase;
  color: ${props => props.theme.colors.textActive};
  
`